import { checkIsInternalCompany } from 'app/auth/authUtils';
import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectBorrowerVestingTypes = createSelector(
  getSystem,
  ({ borrowerVestingTypes }) => borrowerVestingTypes,
);

const selectBorrowerVestingTypesValues = createSelector(
  [selectBorrowerVestingTypes, getIsFromInternalCompany],
  (borrowerVestingTypes, isInternalCompany) =>
    _.sortBy(borrowerVestingTypes, [({ name }) => _.toLower(name)]).map(borrowerVestingType => ({
      ...borrowerVestingType,
      isGlobal: !isInternalCompany && checkIsInternalCompany(borrowerVestingType),
    })),
);

export const selectBorrowerVestingTypesOptions = createSelector(
  selectBorrowerVestingTypesValues,
  borrowerVestingTypes =>
    borrowerVestingTypes.map(({ vestingTypeId, name, isDeleted }) => ({
      name,
      value: vestingTypeId,
      isDeleted,
    })),
);

export const selectFilteredBorrowerVestingTypes = createSelector(
  getDebouncedSearchValue,
  selectBorrowerVestingTypesValues,
  searchItems(borrowerVestingType => [borrowerVestingType.name]),
);
